import React from 'react';
import './footer.css';

export function Footer(props) {
  return (
    <footer role="contentinfo" className="App-footer">
      <p>Built by Steven Chang  <a href="https://github.com/chang-steven/strong-heart-client" target="_blank" rel="noopener noreferrer"><i className="fab fa-github" id="github-icon"></i></a></p>
    </footer>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js